import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  addNewDailyContentToSpicificDate,
  addNewDailyContentToTheEnd,
  getAllDailyBooks,
} from './thunks';
import { DailyContentState } from './types';

export const name = 'dailyContent';

const initialState: DailyContentState = {
  data: [],
  status: 'idle',
  updatingStatus: 'idle',
};
export const getAllDailyBooksAsync = createAsyncThunk(
  name + '/getAllDailyBooks',
  getAllDailyBooks
);
export const addNewDailyContentToSpicificDateAsync = createAsyncThunk(
  name + '/addNewDailyContentToSpicificDate',
  addNewDailyContentToSpicificDate
);
export const addNewDailyContentToTheEndAsync = createAsyncThunk(
  name + '/addNewDailyContentToTheEnd',
  addNewDailyContentToTheEnd
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDailyBooksAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAllDailyBooksAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getAllDailyBooksAsync.rejected, (state, action) => {
        state.status = 'failed';
      })
      .addCase(addNewDailyContentToSpicificDateAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(
        addNewDailyContentToSpicificDateAsync.fulfilled,
        (state, action) => {
          state.updatingStatus = 'idle';
        }
      )
      .addCase(
        addNewDailyContentToSpicificDateAsync.rejected,
        (state, action) => {
          state.updatingStatus = 'failed';
        }
      )
      .addCase(addNewDailyContentToTheEndAsync.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(addNewDailyContentToTheEndAsync.fulfilled, (state, action) => {
        state.updatingStatus = 'idle';
      })
      .addCase(addNewDailyContentToTheEndAsync.rejected, (state, action) => {
        state.updatingStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
